import type { ConsentChangeListener, EmergePrivacyAPI } from './types';
import { buildState } from './storage';
import { fireGtmConsentDefault, fireGtmConsentUpdate } from './gtm-bridge';

/** La CMP nativa necessita di un adapter che differisca l'attivazione fino all'ACK. */
export function blockUnsupportedNativeRelease(native: Record<string, unknown>, tid: string | null): void {
  const error = 'release_native_cmp_unsupported' as const;
  const listeners = new Set<ConsentChangeListener>();
  const denied = () => ({
    ...buildState({ necessary: true, analytics: false, marketing: false, functional: false }),
    registration: 'unrecorded' as const,
  });
  const signalFailure = () => {
    fireGtmConsentUpdate(denied().categories);
    for (const listener of listeners) {
      try { listener(denied()); } catch { /* un adapter guasto non blocca il diniego */ }
    }
    window.dispatchEvent(new CustomEvent('emerge-privacy-configuration-error', { detail: { error } }));
  };
  const api: EmergePrivacyAPI = {
    trackingId: tid,
    consentMode: 'release',
    configurationError: error,
    __emergeWidget: true,
    getConsent: denied,
    updateConsent: async () => { signalFailure(); },
    onConsentChange: (callback) => {
      listeners.add(callback);
      try { callback(denied()); } catch { /* stesso isolamento dei listener normali */ }
      return () => { listeners.delete(callback); };
    },
    openPreferences: () => {
      if (typeof native.openPreferences === 'function') native.openPreferences.call(native);
    },
    clearLocalData: async () => ({ cleared_local: false, cleared_server: false, error }),
  };
  // I metodi di grant nativi non vengono inoltrati come API release verificate.
  // Gli handler interni della CMP restano fuori dal controllo di questo widget.
  window.EmergePrivacy = api as EmergePrivacyAPI & Record<string, unknown>;
  fireGtmConsentDefault();
  signalFailure();
  console.warn(`[EmergePrivacy] ${error}: adapter nativo richiesto prima della modalità release.`);
  window.dispatchEvent(new CustomEvent('emerge-privacy-ready'));
}
